import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-05/lesson-30/task-01";

const task: Slide = {
  titleHtml: "Select the most cost-efficient configuration that is acoustically optimised for music practice.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
